<template>
  <div>
    <ul uk-tab>
      <li
        v-for="(house, iter) in houses"
        :key="house.id"
        :class="{'uk-active': iter === activeIndex}"
        @click="chooseIndex(house)"
      >
        <a href="#">Дом №{{ house.building }}</a>
      </li>
    </ul>
    <ul class="uk-switcher">
      <HouseTab
        v-for="(house, iter) in houses"
        :key="house.id + (activeIndex + ' house')"
        :class="{'uk-active': iter === activeIndex}"
        :house="house"
        :rowSize="rowSize"
      ></HouseTab>
    </ul>
  </div>
</template>

<script>
import HouseTab from '@/views/pages/apartment/HouseTab'
import {mapActions, mapGetters} from 'vuex'

export default {
  name: 'ApartmentAppList',
  components: {HouseTab},
  data: () => ({
    houses: [],
    rowSize: null
  }),
  methods: {
    ...mapActions({
      getActiveIndex: 'GET_ACTIVE_INDEX',
      fetchHouses: 'community/COMMUNITY_HOUSES'
    }),
    getHouses() {
      this.fetchHouses()
        .then(resp => (this.houses = resp))
        .catch(() => (this.houses = []))
    },
    chooseIndex(house) {
      let currentIndex = this.houses.findIndex(item => item === house)
      this.getActiveIndex(currentIndex)
    }
  },
  mounted() {
    this.rowSize = this.$route.params.rowSize
    this.getHouses()
  },
  computed: {
    ...mapGetters({
      activeIndex: 'activeIndex',
      selectedCommunityId: 'community/selectedCommunityId'
    }),
    selectedCommunity() {
      return this.selectedCommunityId
    }
  },
  watch: {
    selectedCommunity() {
      this.getHouses()
    },
    activeIndex() {
      this.rowSize = null
    }
  }
}
</script>

<style scoped>
.uk-tab::before {
  border-bottom: 3px solid rgba(145, 145, 145, 0.16);
}

.uk-tab > .uk-active > a {
  border-bottom: 3px solid rgba(227, 30, 36, 0.8);
}

.uk-tab > * > a {
  font-size: 1.25rem;
  color: #323232 !important;
  text-transform: none;
}

.uk-tab > .uk-active > a {
  font-weight: 500;
  color: #e31e24 !important;
}
</style>
